module.exports = __webpack_public_path__ + "static/img/web.f8194eee.jpg";